var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.8_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return " inline-decorated-channel-name";
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " stream-privacy-original-color-"
    + container.escapeExpression(container.lambda(container.strict(lookupProperty(depth0,"stream"), "stream_id", {"start":{"line":3,"column":100},"end":{"line":3,"column":116}} ), depth0));
},"5":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " style=\"color: "
    + container.escapeExpression(container.lambda(container.strict(lookupProperty(depth0,"stream"), "color", {"start":{"line":3,"column":168},"end":{"line":3,"column":180}} ), depth0))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<span class=\"decorated-channel-name-wrapper"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"inline_with_text"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":43},"end":{"line":1,"column":104}}})) != null ? stack1 : "")
    + "\"><span class=\"channel-privacy-type-icon"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"show_colored_icon"),{"name":"if","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":42},"end":{"line":3,"column":125}}})) != null ? stack1 : "")
    + "\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,lookupProperty(depth0,"show_colored_icon"),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":126},"end":{"line":3,"column":190}}})) != null ? stack1 : "")
    + ">"
    + ((stack1 = container.invokePartial(require("./stream_privacy.hbs"),lookupProperty(depth0,"stream"),{"name":"stream_privacy","data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</span><span class=\"decorated-channel-name\">"
    + container.escapeExpression(container.lambda(container.strict(lookupProperty(depth0,"stream"), "name", {"start":{"line":7,"column":43},"end":{"line":7,"column":54}} ), depth0))
    + "</span></span>\n";
},"usePartial":true,"useData":true});